import React from 'react';
import { twMerge } from 'tailwind-merge';
import { VyTooltip } from '../../VyTooltip';

type VyTableCellProps = {
  value?: React.ReactNode;
  containerClassName?: string;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

// String sentinels treated as "no data" — suppress the tooltip on these so
// users don't see a "--" hover. Alignment is left to the column.
const EMPTY_SENTINELS = new Set(['--', '-', '—', '']);

export const VyTableCell: React.FC<VyTableCellProps> = ({
  value = '--',
  className,
  containerClassName,
  ...props
}) => {
  const tooltipContent =
    typeof value === 'string' && EMPTY_SENTINELS.has(value) ? undefined : value;

  return (
    <VyTooltip tooltipContent={tooltipContent} placement="top">
      <div {...props} className={twMerge('flex w-full items-center justify-center', containerClassName)}>
        <p className={twMerge('truncate font-sans text-black', className)}>{value}</p>
      </div>
    </VyTooltip>
  );
};
